import React from "react";
import { DependencyInjectionProvider } from "@whatslly/commons/di";
import { DOMInjectorProvider } from "./DOMInjector";
import type { Container } from "inversify";

export const App: React.FC<{ container: Container }> = ({ container }) => (
  <React.StrictMode>
    <DependencyInjectionProvider container={container}>
      <DOMInjectorProvider />
    </DependencyInjectionProvider>
  </React.StrictMode>
);
